import React, {useState} from "react";
import { Box,Button } from "@mui/material";
import { customerservice } from "../../../../config";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Swal from "sweetalert2";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Joyride from "react-joyride"; // Import Joyride

const base_url = customerservice.uri;

// Define Joyride tour steps
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Approve Customer Transfer, where you can approve a customer's mobile number transfer.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific approval request by name or other criteria.",
    placement: "bottom",
  },
  // {
  //   target: ".dynamic-table-add-button",
  //   content: "Click this button to add a new next of kin.",
  //   placement: "right",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions to approve for each transfer from this dropdown.",
    placement: "left",
  },
];

const CustomerMobileNumberApproval = () => {
    const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  
  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    phoneNumberTransferApproval: {
      key: "accepttransfer",
      button_name: "Accept",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: (row) =>
        row.Newidnumber ? "CustomerNationIdTransferApproval" : "customerPhoneNumberTransferApproval",
      inputObjectName: (row) =>
        row.Newidnumber ? "Id_Number_Transfer_Approval" : "phone_Number_Transfer_Approval",
    },
    rejectPhoneNumberTransfer: {
      key: "rejecttransfer",
      button_name: "Reject",
      Show_Button: true,
      permission: "ActivatePermission",
      modelName: (row) =>
        row.Newidnumber ? "CustomerNationIdTransferApproval" : "customerPhoneNumberTransferApproval",
      inputObjectName: (row) =>
        row.Newidnumber ? "Id_Number_Transfer_Approval" : "phone_Number_Transfer_Approval",
    },
    dataObject: {
      ignoreFields: [
        "CreateDate",
        "UpdateDate",
        "IsActive",
        "DateApproved",
        "AmountBeforeUpdate",
      ],
      objectName: "allCustomerPhoneTransfers",
      parameters: null,
      inputObjectName: null,
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      {/* Joyride Component */}
            <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />
            {/* Top Bar */}
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
                      Start Page Tour
                    </Button>
                  </Box>
      <DynamicTableForJson
        title="Approve Customer Transfer"
        subtitle="Approve ID or Phone Number Transfer"
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Still passed in case DynamicTable needs it
      />
    </Box>
  );
};

export default CustomerMobileNumberApproval;